import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import ProcedureCheckboxList from "./procedures-checkbox-list.component";
import instance from "../../util/axios";
import { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DoctorsDropdownContainer from "../Appointments/doctors-dropdown-container.component";
import ActiveContext from "../../Context/Context";

const SplitProceduresDialog = ({
  completedProceduresDialog,
  setCompletedProceduresDialog,
  updatePatientActions,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const checkboxRefs = useRef([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [enableDialog, setEnableDialog] = useState(false);
  const { showAddForm } = useContext(ActiveContext);

  const {
    openCompletedProceduresDialog,
    appointmentProcedures,
    userId,
    scanId,
    scn,
  } = completedProceduresDialog;
  const handleDialogClose = () => {
    setCompletedProceduresDialog((prev) => ({
      ...prev,
      openCompletedProceduresDialog: false,
    }));
  };

  const completeAppointmentProcedure = async (procedures) => {
    const doctor = selectedDoctor;
    try {
      setLoading(true);
      const response = await instance.put(
        `/admin/v1/clinic/user/appointments/${scanId}/procedures`,
        { procedures, doctor }
      );
      if (response.status === 200) {
        setLoading(false);
        handleDialogClose();
        await updatePatientActions("Completed", userId, scanId, true, null, scn);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleConfirm = async () => {
    const checkedProcedures = checkboxRefs.current.map((ref, index) => ({
      label: appointmentProcedures[index].label,
      value: ref.checked,
    }));
    const notAllCompleted = checkedProcedures.some(
      (procedure) => procedure.value === false
    );
    if (notAllCompleted) {
      await completeAppointmentProcedure(checkedProcedures);
    }
  };
  
  const showDialogContext = showAddForm ? "" : t("split-procedure-dialog-context");

  return (
    <ConfirmationDialog
      open={openCompletedProceduresDialog}
      handleClose={handleDialogClose}
      handleConfirm={handleConfirm}
      confirmationButtonText={t("Confirm")}
      dialogTitle={t("split-procedure-dialog-title")}
      dialogContentText={showDialogContext}
      loading={loading}
      enableDialog={enableDialog}
    >
      <ProcedureCheckboxList
        checkboxRefs={checkboxRefs}
        procedures={appointmentProcedures}
        setCompletedProceduresDialog={setCompletedProceduresDialog}
      />
      <DoctorsDropdownContainer
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor}
        setEnableDialog={setEnableDialog}
      />
    </ConfirmationDialog>
  );
};

export default SplitProceduresDialog;
